import {
    IconBook,
    IconBrandTelegram,
    IconFileText,
    IconMessages,
    IconShield,
    IconUsers,
} from '@tabler/icons-react';
import { TELEGRAM_CHANNEL_URL } from '../../config/contacts';

export const LINK_SECTIONS = [
    {
        id: 'service',
        title: 'Сервис',
        items: [
            {
                id: 'help',
                title: 'Справка',
                hint: 'Инструкции и ответы',
                note: 'Пожалуйста, ознакомьтесь',
                to: '/help',
                Icon: IconBook,
            },
            {
                id: 'contacts',
                title: 'Контакты',
                hint: 'Реквизиты',
                to: '/info',
                Icon: IconUsers,
            },
            {
                id: 'support-chat',
                title: 'Чат поддержки',
                hint: 'Задать вопрос',
                action: 'supportChat',
                Icon: IconMessages,
            },
            {
                id: 'telegram',
                title: 'Telegram-канал',
                hint: 'Новости и обновления',
                href: TELEGRAM_CHANNEL_URL,
                Icon: IconBrandTelegram,
            },
        ],
    },
    {
        id: 'legal',
        title: 'Документы',
        items: [
            {
                id: 'privacy',
                title: 'Политика конфиденциальности',
                to: '/privacy',
                Icon: IconShield,
            },
            {
                id: 'terms',
                title: 'Правила использования',
                to: '/terms',
                Icon: IconFileText,
            },
        ],
    },
];
